module.exports = __webpack_public_path__ + "media/images/version_merge/cta_banner_girl-72e86a1594a55d6235952ca46b80b127.jpg";